"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _createIconComponent = _interopRequireDefault(require("../utils/createIconComponent"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const AppleMusicIcon = (0, _createIconComponent.default)({
  content: ( /*#__PURE__*/_react.default.createElement("g", null, /*#__PURE__*/_react.default.createElement("path", {
    d: "M7 0a7 7 0 100 14A7 7 0 007 0zm0 .773a6.228 6.228 0 010 12.454A6.223 6.223 0 01.778 7 6.223 6.223 0 017 .773z"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M10 3L5.08 4.188h-.006v1.788h.006v3.196a1.618 1.618 0 00-.763-.185C3.589 8.987 3 9.44 3 9.997 3 10.551 3.589 11 4.319 11s1.35-.448 1.324-1.004l-.014-.285-.032-3.864 3.887-.937v3.53a1.593 1.593 0 00-.831-.225c-.73 0-1.319.453-1.319 1.009 0 .556.589 1.003 1.319 1.003s1.343-.447 1.343-1.003v-.016L10 3z"
  })))
});
AppleMusicIcon.displayName = 'AppleMusicIcon';
var _default = exports.default = AppleMusicIcon;